import { useEffect, useRef, useState } from "react";
import "./VictoryScreen.scss";
import useVictoryAudio from "../../../utils/audio/victoryAudio";
import ConfettiAnimation from "./ConfettiAnimation/ConfettiAnimation";
import LightRaysAnimation from "./LightRayAnimation/LightRay";
import { Color } from "chess.js";
import { isUserOnTV } from "@sinclair-digital/cabin-auth-library";

export default function VictoryScreen({ winner }: { winner: Color }) {
    const KING_STROKE = `/images/victoryScreen/${winner}-king-stroke.webp`;
    const [showConfetti, setShowConfetti] = useState(false);
    const playVictoryAudio = useVictoryAudio();
    const confettiRef = useRef<HTMLDivElement>(null);
    const isTV = isUserOnTV();

    useEffect(() => {
        playVictoryAudio(); // plays the vicotory audio sound

        // Only show confetti if not on TV
        if (!isTV) {
            const confettiDelay = setTimeout(() => setShowConfetti(true), 1500); // Delays the confetti animation by 1.5 seconds to allow the victory audio to play first and horns to get into position.

            return () => {
                clearTimeout(confettiDelay);
            };
        }
    }, [playVictoryAudio, isTV]);

    return (
        <div className="victory-screen" ref={confettiRef}>
            {!isTV && (
                <div className="horns horns-left">
                    <img src="/images/victoryScreen/horn-left.webp" alt="horn-left-top" />
                    <img src="/images/victoryScreen/horn-left.webp" alt="horn-left-middle" />
                    <img src="/images/victoryScreen/horn-left.webp" alt="horn-left-bottom" />
                </div>
            )}
            {showConfetti && (
                <>
                    <div className="confetti-wrapper confetti-left top">
                        <ConfettiAnimation side="left" />
                    </div>
                    <div className="confetti-wrapper confetti-left middle">
                        <ConfettiAnimation side="left" />
                    </div>
                    <div className="confetti-wrapper confetti-left bottom">
                        <ConfettiAnimation side="left" />
                    </div>
                    <div className="confetti-wrapper confetti-right top">
                        <ConfettiAnimation side="right" />
                    </div>
                    <div className="confetti-wrapper confetti-right middle">
                        <ConfettiAnimation side="right" />
                    </div>
                    <div className="confetti-wrapper confetti-right bottom">
                        <ConfettiAnimation side="right" />
                    </div>
                </>
            )}

            <div className="victory-king">
                <div className="king-wrapper">
                    <LightRaysAnimation />

                    <img src={KING_STROKE} className="king-main glow" alt={`${winner} king`} />
                </div>
                <div className="checkmate-banner">
                    <div>Checkmate</div>
                    <div className="winner-line">{winner === "w" ? "White" : "Black"} wins!</div>
                </div>
            </div>
            {!isTV && (
                <div className="horns horns-right">
                    <img src="/images/victoryScreen/horn-right.webp" alt="horn-right-top" />
                    <img src="/images/victoryScreen/horn-right.webp" alt="horn-right-top" />
                    <img src="/images/victoryScreen/horn-right.webp" alt="horn-right-top" />
                </div>
            )}
        </div>
    );
}
